import SurveyLanding from './SurveyLanding';

export default SurveyLanding; 